export const labels = {
	orientationNotSupported: {
		label: "Label.MobileCreator.OrientationNotSupported.Landscape",
		default: "Please rotate your device to portrait orientation.",
	},
};
